WiseMetering.Views.EditSiteTag = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'site_tag',
    template: 'templates/site_tags/edit',
    title: () => i18next.t('modal.title.site_tags.edit')
});
